module.exports = __webpack_public_path__ + "static/media/Poppins-Medium.bc10f2d9.ttf";